export default "/images/28683e627ca6fdddff2d1e6583a6f220.avif";